import { Preferences } from '@capacitor/preferences';
import { isPlatform } from '@ionic/core';
import localforage from 'localforage';
import { type WebStorage } from 'redux-persist';

class CapacitorStorage implements WebStorage {
  public async getItem(key: string): Promise<string | null> {
    const prefResult = await Preferences.get({ key: key });
    return prefResult.value;
  }

  public async setItem(key: string, item: string): Promise<void> {
    await Preferences.set({ key, value: item });
  }

  public async removeItem(key: string): Promise<void> {
    await Preferences.remove({ key });
  }
}

class LocalForageStorage implements WebStorage {
  private readonly lf = localforage.createInstance({ name: 'persist' });

  public async getItem(key: string): Promise<string | null> {
    return await this.lf.getItem(key);
  }

  public async setItem(key: string, item: string): Promise<void> {
    await this.lf.setItem(key, item);
  }

  public async removeItem(key: string): Promise<void> {
    await this.lf.removeItem(key);
  }
}

// Important that this is `capacitor` and not `mobile`, we are checking if we have access to native APIs
export const capacitorStorage = isPlatform('capacitor') ? new CapacitorStorage() : new LocalForageStorage();

export class PersistenceStatus {
  private static readonly PERSIST_PURGE_KEY = 'persistence:purge';

  public static get isPurging(): boolean {
    return !!window.localStorage.getItem(this.PERSIST_PURGE_KEY);
  }

  public static set isPurging(value: boolean) {
    if (value) window.localStorage.setItem(this.PERSIST_PURGE_KEY, 'true');
    else window.localStorage.removeItem(this.PERSIST_PURGE_KEY);
  }
}
